"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const common_1 = require("../../../../utils/common");
const components_1 = require("./components");
const expertLicense_1 = __importDefault(require("../modals/expertLicense"));
const expertCertificate_1 = __importDefault(require("../modals/expertCertificate"));
const expertEducation_1 = __importDefault(require("../modals/expertEducation"));
const saveExpert_1 = __importDefault(require("../modals/saveExpert"));
const expertExpertize_1 = __importDefault(require("../modals/expertExpertize"));
const expertService_1 = __importDefault(require("../modals/expertService"));
const expertLanguages_1 = __importDefault(require("../modals/expertLanguages"));
const expertStates_1 = __importDefault(require("../modals/expertStates"));
const snackBar_1 = __importDefault(require("../modals/snackBar"));
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
class SingleExpert extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalOpen: false,
            selectedExpert: null,
            currentPage: 1,
            count: 0,
            q: ''
        };
    }
    async componentDidMount() {
        const expertId = common_1.urlPrams("uid");
        const action = common_1.urlPrams("action");
        this.props.setAdminActionType(action);
        if (!expertId && !action) {
            return null;
        }
        this.props.resetExpert();
        if (action === 'edit' && expertId) {
            await this.props.getAdminSingleExpert(expertId);
        }
        else {
            this.props.initCreateExpert(this.props.expert);
        }
        this.props.getStates();
        this.props.getServices();
        this.props.getAreas();
    }
    async onSubmit() {
        this.props.triggerModal({
            key: 'experts.save.data', val: {
                type: 'save',
                text: 'Save'
            }
        });
        this.props.triggerModal({ key: 'experts.save.open', val: true });
    }
    async submitAndPublish() {
        this.props.triggerModal({
            key: 'experts.save.data',
            val: {
                type: 'publish',
                text: 'Save & Publish'
            }
        });
        this.props.triggerModal({ key: 'experts.save.open', val: true });
        /* this.props.editExpert({key: "status", val: 1});
         await this.props.submitEdit();*/
    }
    openPreview() {
        const expertId = common_1.urlPrams("uid");
        window.open(`#/directory/expertsProfile?uid=${expertId}`);
    }
    render() {
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, direction: "row", justify: "center", alignItems: "center" },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 10 },
                    this.props.adminActionType === 'edit' && react_1.default.createElement(components_1.EditExpert, null),
                    this.props.adminActionType === 'create' && react_1.default.createElement(components_1.CreateExpert, null),
                    react_1.default.createElement("div", { className: 'profile-action-box' },
                        react_1.default.createElement("div", { className: "w-100 save-never-mind mt-0 mb-10" },
                            react_1.default.createElement(core_1.Button, { onClick: () => this.openPreview(), variant: "contained", color: "primary", disableRipple: true, className: 'v2-btn v2-btn-primary' }, "Preview"),
                            react_1.default.createElement(core_1.Button, { onClick: () => this.onSubmit(), variant: "contained", color: "primary", disableRipple: true, className: 'v2-btn v2-btn-primary' }, "Save"),
                            react_1.default.createElement(core_1.Button, { onClick: () => this.submitAndPublish(), variant: "contained", color: "primary", disableRipple: true, className: 'v2-btn v2-btn-primary' }, "Save & Publish"),
                            react_1.default.createElement(core_1.Button, { disableRipple: true, variant: "contained", onClick: () => location.reload(), className: "v2-btn v2-btn-tertiary" }, "Never Mind"))))),
            react_1.default.createElement(expertLicense_1.default, null),
            react_1.default.createElement(expertEducation_1.default, null),
            react_1.default.createElement(expertCertificate_1.default, null),
            react_1.default.createElement(saveExpert_1.default, null),
            react_1.default.createElement(snackBar_1.default, null),
            react_1.default.createElement(expertExpertize_1.default, null),
            react_1.default.createElement(expertService_1.default, null),
            react_1.default.createElement(expertLanguages_1.default, null),
            react_1.default.createElement(expertStates_1.default, null)));
    }
}
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts: experts.list,
        count: experts.count,
        visibleCount: experts.visibleCount,
        expert: experts.expert,
        adminActionType: experts.adminActionType
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getAdminSingleExpert: (data) => dispatch(expertsSlice_1.getAdminSingleExpert(data)),
        submitEdit: () => dispatch(expertsSlice_1.submit()),
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        initEditExpert: (data) => dispatch(expertsSlice_1.initEditExpert(data)),
        initCreateExpert: (data) => dispatch(expertsSlice_1.initCreateExpert(data)),
        getStates: () => dispatch(expertsSlice_1.getMutatedStates()),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        getAreas: () => dispatch(expertsSlice_1.getAreas()),
        getServices: () => dispatch(expertsSlice_1.getServices()),
        resetExpert: () => dispatch(expertsSlice_1.initEditExpert(null)),
        setAdminActionType: (val) => dispatch(expertsSlice_1.setAdminActionType(val))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SingleExpert);
